import type { AuthSession, SessionResponse } from "./types"

export async function readServerSession(): Promise<AuthSession | null> {
  const response = await fetch("/api/dashboard/auth/session", {
    method: "GET",
    credentials: "same-origin",
  })
  if (!response.ok) return null
  const payload = (await response.json()) as SessionResponse
  if (!payload.authenticated) return null
  return sessionFromResponse(payload)
}

export async function refreshServerSession(): Promise<AuthSession | null> {
  const response = await fetch("/api/dashboard/auth/refresh", {
    method: "POST",
    credentials: "same-origin",
  })
  if (!response.ok) return null
  const payload = (await response.json()) as SessionResponse
  if (!payload.authenticated) return null
  return sessionFromResponse(payload)
}

function sessionFromResponse(payload: SessionResponse): AuthSession {
  return {
    user: payload.user,
    expiresAt: payload.expiresAt,
    idleExpiresAt: payload.idleExpiresAt,
    absoluteExpiresAt: payload.absoluteExpiresAt,
  }
}
